export default __webpack_public_path__ + "7b9eee971dced113791e3bc8193e0d6a.webp";